<template>
  <div class="row" style="margin-right: 0px;margin-left: 0px;">
    <div
      v-for="item in fabricList"
      :key="item.id"
      class="fabric-info__container col-md-6 col-xl-5"
    >
      <div class="d-flex justify-content-between align-items-center head_div">
        <div style="color:white" class="weight">
          {{ item.fabricColorNo }}
        </div>
        <div>
          <el-button class="button_class" size="mini">
            {{ item.fabricColorTitle }}</el-button
          >
        </div>
      </div>

      <div class="d-flex justify-content-start body_div">
        <div>
          <el-image
            :src="
              item.defaultImageUrl
                ? $osscdn(item.defaultImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            :preview-src-list="[
              item.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            class="el_image"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic.jpg" class="el_image" />
            </div>
          </el-image>
          <div class="weight center">{{ item.fabricPositionName }}</div>
        </div>

        <div class="ml-2">
          <div class="weight">{{ item.fabricName }}</div>
          <div class="weight mt-1">
            {{ item.fabricWeight }} {{ item.fabricWeightUnit }}
          </div>
          <div class="div_title mt-1">{{ item.fabricContent }}</div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center body_div">
        <div>
          <el-tag
            size="mini"
            v-if="item.isSpecify == 'Y'"
            :type="'V'"
            class="mr-2"
          >
            {{ '指定供应商' }}
          </el-tag>
          <el-tag size="mini" v-if="item.isCustomerProvide == 'Y'" :type="'S'">
            {{ '客供' }}
          </el-tag>
        </div>
        <div>
          <div class="weight">
            {{ item.scmName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    fabricList: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: true },
  },
  components: {},
  mixins: [],
  data() {
    return {}
  },
  watch: {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.head_div {
  background-color: #28a745;
  width: 100%;
  height: 30px;
  padding: 0px 8px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.button_class {
  border-radius: 5px !important;
  height: 25px;
  color: #4f4f4f;
  font-size: 14px;
  line-height: 1px;
  font-weight: 900;
}
.weight {
  font-weight: 600;
}
.center {
  text-align: center;
}

.el_image {
  width: 100px;
  height: 65px;
}

.div_title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.body_div {
  padding: 10px;
  font-size: 14px;
}

.fabric-info__container {
  background-color: white;
  color: #101010;
  border-radius: 5px;
  margin: 10px 0px 10px 10px;
  max-width: 413px;
  min-width: 350px;
  height: 180px;
}

::v-deep {
  .el-tag--V {
    color: #ffffff;
    background-color: #e99d42;
    border: #e99d42;
  }

  .el-tag--S {
    color: #ffffff;
    background-color: #fa5c7c;
    border: #fa5c7c;
  }
}
::v-deep {
  .col-md-6 {
    position: relative;
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .col-xl-5 {
    position: relative;
    width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
